<div class="command-time-line">
  <div class="command-time-line__card-container">
    <mat-card>
      <mat-card-content class="command-time-line__card-container-content">
        <div class="command-time-line__status">
          <mat-icon color="accent">check_circle</mat-icon>
          Created
        </div>
        <div class="command-time-line__date">{{ createdDate() }}</div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="command-time-line__line"></div>
  <div class="command-time-line__card-container">
    <mat-card>
      <mat-card-content class="command-time-line__card-container-content">
        @if (hasSentCommand() || hasSentToServerCommand()) {
          <div class="command-time-line__status">
            <mat-icon color="accent">check_circle</mat-icon>
            Sent
          </div>
          @if (command()?.remoteSendAttempts) {
            <div class="command-time-line__date">Attempts {{ command()?.remoteSendAttempts }}</div>
          }
          <div>{{ sendToDeviceTime() }}</div>
        } @else if (hasFailedSentToServerCommand()) {
          <div class="command-time-line__status">
            <mat-icon color="warn">cancel</mat-icon>
            Failed sending
          </div>
        } @else if (hasFailedSentToDeviceCommand()) {
          <div class="command-time-line__status">
            <mat-icon color="warn">cancel</mat-icon>
            Failed sending
          </div>
        } @else if (hasCanceledCommand()) {
          <div class="command-time-line__status">
            <mat-icon color="warn">sync_problem</mat-icon>
            Canceled
          </div>
          @if (command()?.remoteSendAttempts) {
            <div class="command-time-line__date">Attempts {{ command()?.remoteSendAttempts }}</div>
          }
        }
      </mat-card-content>
    </mat-card>
  </div>
  <div class="command-time-line__line"></div>
  <div class="command-time-line__card-container">
    <mat-card>
      <mat-card-content class="command-time-line__card-container-content">
        @if (hasAcknowledgedCommand()) {
          <div class="command-time-line__status">
            <mat-icon color="accent">check_circle</mat-icon>
            Acknowledged
          </div>
          <div>{{ receivedResponseTime() }}</div>
        } @else if (hasFailedExpiredCommand()) {
          <div class="command-time-line__status">
            <mat-icon color="warn">cancel</mat-icon>
            Failed expired
          </div>
          <div>{{ receivedResponseTime() }}</div>
        } @else if (hasFailedOnDeviceCommand()) {
          <div class="command-time-line__status">
            <mat-icon color="warn">cancel</mat-icon>
            Failed on device
          </div>
          <div>{{ receivedResponseTime() }}</div>
        } @else if (hasSentToServerCommand() || hasSentCommand()) {
          <div class="command-time-line__status">
            <mat-icon class="command-time-line__icon">more_horiz</mat-icon>
            Not yet acknowledged
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
